import { ChevronDown, HelpCircle, Settings } from "lucide-react";

export function SampleHeader() {
  return (
    <header className="fixed top-0 right-0 left-[270px] z-10 h-12 border-gray-200 border-b bg-white">
      <div className="flex h-full items-center justify-between px-4">
        {/* 左: 採用モード切替 */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 rounded border border-gray-200 px-3 py-1.5">
            <span className="text-sm font-medium text-gray-800">採用</span>
            <span className="text-xs text-gray-400">コーポレート</span>
            <ChevronDown className="h-3 w-3 text-gray-400" />
          </div>
          <span className="text-sm text-blue-600 hover:underline cursor-pointer">
            &lt; 企業・グループ画面に戻る
          </span>
        </div>

        {/* 右: ヘルプ・設定・ユーザー */}
        <div className="flex items-center gap-4">
          <button
            className="flex items-center gap-1 text-gray-600 text-sm hover:text-gray-800"
            type="button"
          >
            アシストモード
            <ChevronDown className="h-3 w-3" />
          </button>
          <button
            className="flex items-center gap-1 text-gray-600 text-sm hover:text-gray-800"
            type="button"
          >
            <HelpCircle className="h-4 w-4" />
            ヘルプ
            <ChevronDown className="h-3 w-3" />
          </button>
          <button className="text-gray-400 hover:text-gray-600" type="button">
            <Settings className="h-4 w-4" />
          </button>
          <div className="h-5 w-px bg-gray-200" />
          <div className="text-right text-xs">
            <div className="text-gray-400">株式会社サンプル</div>
            <div className="font-medium text-gray-800">採用 太郎</div>
          </div>
          <ChevronDown className="h-3 w-3 text-gray-400" />
        </div>
      </div>
    </header>
  );
}
